<table class="text" style="width: 80%">
    <tr>
        <td class="bold">
            Myndighed
        </td>
        <td></td>
        <td class="bold">System</td>
        <td></td>
    </tr>
    <tr>
        <td>
            Navn:
        </td>
        <td>{{authority?.name}}</td>
        <td>Navn:</td>
        <td>{{itSystem?.name}}</td>
    </tr>
    <tr>
        <td>
            CVR:
        </td>
        <td>{{authority?.cvr}}</td>
        <td>UUID:</td>
        <td>{{itSystem?.uuid}}</td>
    </tr>
    <tr>
        <td>
           
        </td>
        <td></td>
        <td>Leverandør:</td>
        <td>{{itSystemData?.name}}</td>
    </tr>
    <tr>
        <td>
           
        </td>
        <td></td>
        <td>CVR:</td>
        <td>{{itSystem?.userSystemCVR}}</td>
    </tr>
    
</table>